import { render, staticRenderFns } from "./ColunaIcone.vue?vue&type=template&id=00e419e0&scoped=true"
import script from "./ColunaIcone.vue?vue&type=script&lang=js"
export * from "./ColunaIcone.vue?vue&type=script&lang=js"
import style0 from "./ColunaIcone.vue?vue&type=style&index=0&id=00e419e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e419e0",
  null
  
)

export default component.exports